import { Paper, Box, Grid, Typography, Button } from '@mui/material';
import { WALLET_NON_MEMBER_PHRASES } from '@/consts/phrases/walletPhrases';
import { IWalletNonMemberData } from '@/types/types';
import { usePhrase } from '@/hooks';
import { Link } from '@/components/general/Link/Link';
import { PaymentAmount } from '@/components/blocks/wallet/PaymentAmount/PaymentAmount';
import { isArrayWithValues } from '@/utils/fp';

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

interface NonMemberSummaryDetailsProps {
    data: IWalletNonMemberData;
    token: string;
}

export const NonMemberSummaryDetails = ({ data, token }: NonMemberSummaryDetailsProps) => {
    const { t } = usePhrase();

    const firstTransaction = data?.payments?.[0];

    const paymentMethodId = data?.paymentForm?.paymentMethodId;
    const paymentMethodPhraseId = data?.paymentMethods.find(
        (paymentMethod) => paymentMethod.paymentMethodId === paymentMethodId,
    )?.phraseId;

    return (
        <>
            <Paper sx={{ p: 3, mt: 3 }}>
                <Box sx={{ mt: 2 }}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <PaymentAmount transactionData={firstTransaction} />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography variant="greyLabel">
                                {t(WALLET_NON_MEMBER_PHRASES.PAYMENT_METHOD_LABEL)}:
                            </Typography>
                            <Typography variant="subtitle1">
                                {paymentMethodPhraseId ? t(paymentMethodPhraseId) : '-'}
                            </Typography>
                        </Grid>
                        {isArrayWithValues(data?.summary) &&
                            data?.summary.map((infoItem) => (
                                <Grid size={{ xs: 12, md: 6 }} key={infoItem?.value}>
                                    {infoItem?.phraseId && (
                                        <Typography variant="greyLabel">
                                            {t(infoItem.phraseId)}:{' '}
                                        </Typography>
                                    )}
                                    {infoItem?.value && (
                                        <Typography variant="subtitle1">
                                            {infoItem.value}
                                        </Typography>
                                    )}
                                </Grid>
                            ))}
                    </Grid>
                </Box>
            </Paper>
            {data.isRegistrationAllowed && (
                <Grid
                    container
                    spacing={2}
                    sx={{
                        justifyContent: 'center',
                        mt: 4,
                    }}
                >
                    <Link
                        href={`/?reg_type=${data.registrationType}&token=${token}&hh_id=32773`}
                        passHref
                    >
                        <Button variant="outlined">
                            {t(WALLET_NON_MEMBER_PHRASES.JOIN_BUTTON)} <ArrowRightAltIcon />
                        </Button>
                    </Link>
                </Grid>
            )}
        </>
    );
};
